<template>
  <div
    class="ai-visibility-data-table-cell"
    :class="[
      `ai-visibility-data-table-cell--${align}`,
      { 'ai-visibility-data-table-cell--muted': muted },
    ]"
    :role="header ? 'columnheader' : 'cell'"
    :style="cellStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DataTableCell',
  props: {
    align: {
      type: String,
      default: 'left',
    },
    width: {
      type: String,
      default: '',
    },
    muted: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cellStyle () {
      if (!this.width) {
        return {}
      }
      return {
        flex: `0 0 ${this.width}`,
        maxWidth: this.width,
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-data-table-cell {
  flex: 1 1 0;
  min-width: 0;
  color: var(--v-mainColor-base);
  font-size: 16px;
  padding: 10px 20px;

  &.right-border {
    border-right: 1px solid #DADADA;
    height: stretch;
  }
}

.ai-visibility-data-table-cell--center {
  text-align: center;
}

.ai-visibility-data-table-cell--right {
  text-align: right;
}

.ai-visibility-data-table-cell--muted {
  color: var(--v-gray36Color-base);
}
</style>
